import axios from "@/index";
const system = {
  state: {
    roles: [],
    roleInfo: {},
    menuTree: [],
    checkedKeys: [],
    allMenuTree: [],
    userList: {},
    roleOptions: [],
    userInfo: {}
  },
  getters: {},
  actions: {
    getRoleList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setRoleList", (state, { roles: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getRoleInfoById: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setRoleInfoById",
                (state,
                {
                  roleInfo: response.data.roleInfo,
                  menuTree: response.data.menuTree,
                  checkedKeys: response.data.checkedKeys
                })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getMenuTree: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setMenuTree",
                (state,
                {
                  allMenuTree: response.data
                })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getUserList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setUserList", (state, { userList: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getRoleInfoList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setRoleInfoList",
                (state, { roleOptions: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getUserInfoById: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setUserInfoById", (state, { userInfo: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setRoleList(state, action) {
      state.roles = action.roles;
    },
    setUserList(state, action) {
      state.userList = action.userList;
    },
    setRoleInfoById(state, action) {
      state.roleInfo = action.roleInfo;
      state.menuTree = action.menuTree;
      state.checkedKeys = action.checkedKeys;
    },
    setMenuTree(state, action) {
      state.allMenuTree = action.allMenuTree;
    },
    setRoleInfoList(state, action) {
      state.roleOptions = action.roleOptions;
    },
    setUserInfoById(state, action) {
      state.userInfo = action.userInfo;
    }
  }
};
export default system;
